import React, { Component } from "react";
import LeftArrow from "./left_arrow";
import RightArrow from "./right_arrow";
import CustomizedExpansionPanel from "./CustomizedExpansionPanel";
import Htmlparser from "html-react-parser";
import { urlify } from "../strings";
import Evaluation from "../Evaluation";
import "./../Chat.css";

class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
      Cards: this.props.Cards ? this.props.Cards : [],
      length: this.props.Cards ? this.props.Cards.length : 0,
    };
  }

  goToPrevSlide() {
    let index = this.state.activeIndex;
    let length = this.state.length;

    if (index < 1) {
      index = length - 1;
    } else {
      index--;
    }

    this.setState({
      activeIndex: index,
    });
  }

  goToNextSlide() {
    let index = this.state.activeIndex;
    let length = this.state.length;

    if (index === length - 1) {
      index = 0;
    } else {
      index++;
    }

    this.setState({
      activeIndex: index,
    });
  }

  render_Buttons = (buttons) =>
    buttons
      ? buttons.map((button, index) => {
          return (
            <button
              key={`button-${index}`}
              value={button.action}
              className="infost-btnCaro1  infost-expand infoSt-butt"
              type="button"
              disabled={button.disabled ? true : false}
              onClick={() => {
                this.props.sendButtonAnswerofCards(button);
              }}
              style={this.props.getStyleFromString(button.style)}
            >
              <span className="infoSt-span"> {button.title}</span>
            </button>
          );
        })
      : "";

  render() {
    return (
      <div className="infoSt-slider" key={`${this.props.index + "_slider"}`}>
        <div className="infoSt-slider-items">
          {this.state.length > 1 ? (
            <div
              className="  infoSt-left"
              style={{
                display:
                  `${this.props.index + "_slider"}` === "0_slider" &&
                  this.props.displayButtons
                    ? "flex"
                    : "none",
              }}
            >
             
              <LeftArrow goToPrevSlide={() => this.goToPrevSlide()} />
            </div>
          ) : (
            ""
          )}
          <section>
            {this.state.Cards.map((card, index) => (
              <div
                className={
                  index === this.state.activeIndex
                    ? "infoSt-active"
                    : "infoSt-slide"
                }
                key={index}
              >
                <div className="infostCarousel-inner " role="listbox">
                  <div className="infostCarousel-item infoStcarousel-item">
                    {card.photoUrl && card.photoUrl != "" ? (
                      <div className="infoSt-logo">
                        <div className="infost-imgslide">
                          <img
                            src={card.photoUrl}
                            onError={(i) => (i.target.style.display = "none")}
                            alt="First slide"
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className={`${
                        this.state.length === 1
                          ? "infostCarousel-caption-center"
                          : "infostCarousel-caption"
                      }`}
                    >
                      <h3
                        className={
                          this.props.lang == "en"
                            ? "infost-ltr-mr"
                            : "infost-mr"
                        }
                      >
                        {card.title
                          ? Htmlparser(urlify(card.title, this.props.lang))
                          : card.title}
                      </h3>
                      <p
                        className={
                          this.props.lang == "en"
                            ? "infoSt-ltr-mt-1"
                            : "infoSt-mt-1"
                        }
                      >
                        {card.description
                          ? Htmlparser(
                              urlify(card.description, this.props.lang)
                            )
                          : card.description}
                      </p>
                    </div>
                    {this.props.hasEvaluation && index == 0 && (
                      <div
                        className={`${
                          this.state.length === 1
                            ? "infostCarousel-caption-center"
                            : "infostCarousel-caption"
                        }`}
                      >
                        <Evaluation
                          onClickUp={() =>
                            this.props.onClickUp && this.props.onClickUp()
                          }
                          onClickDown={() =>
                            this.props.onClickDown && this.props.onClickDown()
                          }
                        />
                      </div>
                    )}
                    {!card.ExpansionPanel_first ? (
                      <div
                        className="infoSt-btnCaro"
                        style={{
                          display:
                            `${this.props.index + "_slider"}` === "0_slider" &&
                            this.props.displayButtons
                              ? "flex"
                              : "none",
                        }}
                      >
                        {this.render_Buttons(card.buttons)}
                        <CustomizedExpansionPanel
                          Panels={
                            card.expansionPanels &&
                            card.expansionPanels.length > 0
                              ? card.expansionPanels
                              : []
                          }
                          isActive={index === this.state.activeIndex}
                          lang={this.props.lang}
                        />
                      </div>
                    ) : (
                      <div
                        className="infoSt-btnCaro"
                        style={{
                          display:
                            `${this.props.index + "_slider"}` === "0_slider" &&
                            this.props.displayButtons
                              ? "flex"
                              : "none",
                        }}
                      >
                        <CustomizedExpansionPanel
                          key={this.props.generateKey}
                          generateKey={this.props.generateKey}
                          Panels={
                            card.expansionPanels &&
                            card.expansionPanels.length > 0
                              ? card.expansionPanels
                              : []
                          }
                          isActive={index === this.state.activeIndex}
                          lang={this.props.lang}
                        />
                        {this.render_Buttons(card.buttons)}
                      </div>
                    )}

                    {card.buttonsExpansionPanels &&
                    card.buttonsExpansionPanels.length > 0
                      ? card.buttonsExpansionPanels.map((button) => {
                          if (button.type == "Button")
                            return (
                              <div>
                                <button
                                  value={button.action}
                                  className="infost-btnCaro1  infost-expand infoSt-butt"
                                  type="button"
                                  disabled={button.disabled ? true : false}
                                  onClick={() => {
                                    if (button.URL)
                                      window.open(button.URL, "_blank");
                                    else
                                      this.props.sendButtonAnswerofCards(
                                        button
                                      );
                                  }}
                                  style={this.props.getStyleFromString(
                                    button.style
                                  )}
                                >
                                  <span className="infoSt-span">
                                    {" "}
                                    {button.title}
                                  </span>
                                </button>
                              </div>
                            );
                          else if (button.type == "ExpansionPanel")
                            return (
                              <CustomizedExpansionPanel
                                Panels={[button]}
                                isActive={index === this.state.activeIndex}
                                lang={this.props.lang}
                              />
                            );
                        })
                      : ""}
                  </div>{" "}
                </div>
              </div>
            ))}
          </section>
          {this.state.length > 1 ? (
            <div
              className="infoSt-right"
              style={{
                display:
                  `${this.props.index + "_slider"}` === "0_slider" &&
                  this.props.displayButtons
                    ? "flex"
                    : "none",
              }}
            >
              <RightArrow goToNextSlide={() => this.goToNextSlide()} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
export default Slider;

const buttonsExpansionPanels = [
  { title: "Button", type: "Button", action: "1" },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
  { title: "Button", type: "Button", action: "1" },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
  { title: "Button", type: "Button", action: "1" },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
  { title: "Button", type: "Button", action: "1" },
  { title: "Button", type: "Button", action: "1" },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
  { title: "Button", type: "Button", action: "1" },
  {
    title: "ExpansionPanel",
    type: "ExpansionPanel",
    description: "description",
  },
];
